import { UpdateEqptParam, CreateEqptParam } from '../domains/eqptDomain';
import { EqptType } from 'domains/eqptDomain';
import api from 'utils/api';
import { Equipment, ListEqptParam } from 'domains/eqptDomain';
import { Paged, SortParam } from 'domains/appDomain';
import { EqptSchedule } from 'domains/tfDomain';

const buildSortQuery = (sort?: SortParam) =>
  sort?.field ? `&sort=${sort.field},${sort.order}` : '';

const eqptService = {
  getEqptById: async (id: number) => {
    return await api.get<Equipment>(`/api/equipments/${id}`);
  },

  queryEqpts: async (param: ListEqptParam) => {
    const pageNumber = param.page.currentPage - 1;
    const pageSize = param.page.pageSize || 20;
    return await api.post<Paged<Equipment>>(
      `/api/equipments/list?page=${pageNumber}&size=${pageSize}${buildSortQuery(
        param.sort
      )}`,
      param.query
    );
  },

  queryBaseEqpts: async (param: ListEqptParam) => {
    const pageNumber = param.page.currentPage - 1;
    const pageSize = param.page.pageSize || 10;
    return await api.post<Paged<Equipment>>(
      `/api/equipments/listBase?page=${pageNumber}&size=${pageSize}${buildSortQuery(
        param.sort
      )}`,
      param.query
    );
  },

  updateEqpt: async (eqpt: UpdateEqptParam) => {
    return await api.put<Equipment>(`/api/equipments/${eqpt.id}`, eqpt);
  },

  createBaseEqpt: async (eqpt: CreateEqptParam) => {
    return await api.post<Equipment>(`/api/equipments/createBase`, eqpt);
  },

  createOrgEqpt: async (baseId: number) => {
    return await api.post<Equipment>(
      `/api/equipments/createOrg?baseEquipmentId=${baseId}`
    );
  },

  removeEqpt: async (eqptId: number) => {
    return await api.delete<void>(`/api/equipments/${eqptId}`);
  },

  getEqptTypes: async () => {
    return await api.get<EqptType[]>(`/api/equipments/types/list/all`);
  },

  createSchedule: async (eqptId: number, schedule: Partial<EqptSchedule>) => {
    return await api.post<EqptSchedule>(
      `/api/equipments/${eqptId}/turnaround-time`,
      schedule
    );
  },

  updateSchedule: async (eqptId: number, schedule: Partial<EqptSchedule>) => {
    return await api.put<EqptSchedule>(
      `/api/equipments/${eqptId}/turnaround-time/${schedule.id}`,
      schedule
    );
  },

  removeSchedule: async (eqptId: number, scheduleId: number) => {
    return await api.delete<void>(
      `/api/equipments/${eqptId}/turnaround-time/${scheduleId}`
    );
  },
};
export default eqptService;
